'use client';

import { cn } from '@core/utils';
import type { HomeDonationBusinessDto } from '@generated/unauth';

import { ProjectCard } from '@/app/donation/_components/ProjectCard';
import { SPECIFIC_DONATION_STATUS } from '@/app/donation/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface DesignatedDonationProps {
  institutionName: string;
  contents: HomeDonationBusinessDto[];
  totalCount: number;
}

export const DesignatedDonation = ({
  institutionName,
  contents,
  totalCount,
}: DesignatedDonationProps) => {
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const slicedContents = contents.slice(0, isDesktopViewport ? 3 : 4);

  if (totalCount < 1) return null;

  return (
    <section className="mb-80 flex flex-col">
      <h2
        className={cn(
          'mb-24 px-20 text-center font-800 text-Gray-900 typo-h4',
          'mobile-tablet:whitespace-pre-line mobile-tablet:text-start mobile-tablet:font-600 mobile-tablet:typo-body1',
        )}
      >
        {institutionName}에는{'\n'}
        <span className="mobile-tablet:font-500 mobile-tablet:text-Gray-600 mobile-tablet:typo-body3">
          이런 지정기부를 진행하고 있어요
        </span>
      </h2>
      <ul
        className={cn(
          'grid grid-cols-3 gap-24 px-20',
          'mobile-tablet:grid-cols-1',
        )}
      >
        {slicedContents.map((content) => (
          <li key={content.donationBusinessId}>
            <ProjectCard
              title={content.donationBusinessName}
              thumbnailUrl={content.thumbnailUrl}
              businessId={content.donationBusinessId}
              slugId={content.donationBusinessSlugId}
              daysLeft={content.dday}
              donationAmount={content.donationAmount}
              achievementRate={content.achievementRate}
              isEnded={
                content.specificDonationStatus ===
                SPECIFIC_DONATION_STATUS.ENDED
              }
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
